import { createSelector } from "reselect";
import { State } from "../../../redux/state";

export const whatsappChatRoot = (state: State) => state.whatsappChat;

export const chatSelector = createSelector(whatsappChatRoot, (me) => me.chat);